export default function About() {
  return (
    <section id="about" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full uppercase tracking-wide">
            关于桔子
          </span>
          <h2 className="mt-4 text-2xl md:text-3xl font-bold text-foreground-950">海量高清视频 · 一站式免费观看</h2>
          <p className="mt-3 text-foreground-600 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            桔子视频致力于打造最便捷的高清影视聚合平台，汇聚西瓜视频、丝瓜视频等平台优质内容。
          </p>
        </div>

        <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/60">
          <div className="flex flex-col md:flex-row gap-8 items-center">
            <div className="w-20 h-20 md:w-24 md:h-24 shrink-0 rounded-2xl bg-primary-500 flex items-center justify-center">
              <i className="ri-movie-2-line text-background-50 text-3xl md:text-4xl"></i>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-xl md:text-2xl font-bold text-foreground-950 mb-3">桔子视频平台简介</h3>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                桔子视频是一个面向华语观众的免费高清视频聚合平台，实时同步西瓜视频和丝瓜视频等主流站点的最新电视剧、
                热门电影、综艺节目、动漫番剧与纪录片资源。我们通过智能内容分发与链路优化技术，
                确保每一帧画面都以最佳画质流畅呈现。无论您是想追最新热播剧集，还是重温经典老片，
                桔子视频都能提供一站式的便捷入口。本站所有内容完全免费，无需注册登录，即点即播。
              </p>
              <div className="mt-5 flex flex-wrap gap-3 justify-center md:justify-start">
                <span className="px-3 py-1.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full">西瓜视频同步</span>
                <span className="px-3 py-1.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full">丝瓜视频聚合</span>
                <span className="px-3 py-1.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full">高清不缓冲</span>
                <span className="px-3 py-1.5 bg-background-200 text-foreground-700 text-xs font-medium rounded-full">每日更新</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}